import {
  agentInputtingApi,
  updateAgentInfoApi,
  updateAgentAvatarApi,
  getCaptchasApi,
  resetPasswordApi
} from '../api/agent';

const eventOn = emitter => {
  emitter.promiseOn('agentInputting', payload => {
    return agentInputtingApi(payload);
  });

  emitter.promiseOn('updateAgentInfo', payload => {
    return updateAgentInfoApi(payload);
  });
  emitter.promiseOn('updateAgentAvatar', payload => {
    return updateAgentAvatarApi(payload);
  });

  emitter.promiseOn('getCaptchas', payload => {
    return getCaptchasApi(payload);
  });

  emitter.promiseOn('resetPassword', payload => {
    return resetPasswordApi(payload);
  });
};

export default eventOn;
